<template>
	<div class="row">
        <div class="content-wrap">            
            
            <div class="">
                <h1 v-html="languageData['d'+division_id]"></h1>
                <p v-html="languageData['d'+division_id+'_descriptions']"></p>
            </div>
            
            <div class="row">
                <div class="col-md-12">
                    <div class="col-sm-12 col-md-3 col-lg-3" style="display:flex;"> 
                        <div class="side animate-box co-md-3">
                            <input type="text" aria-label="Search Webinar" id="search-webinar" placeholder="Search" class="form-control webinar-srch-box" v-model="srchTitleTerm" @keydown.enter.prevent="searchURLPush()">
                            <button type="button" aria-label="search" class="btn submit btn-primary webinar-search-btn" @click="searchURLPush()"><i class="icon-search3"></i></button>
                            <br/>
                            

                            <br/>
                            <ul v-if="mainDataAll.length>1" class="category" role="tablist" >                           
                                <li role="none" v-for="(webmodul,kyee) in mainDataAll" :key="kyee">
                                    <router-link role="tab" :to="'/webinars/?d='+division_id+'&m='+webmodul['id_module']+'&cd='+cosmic_division_id" :aria-selected="module_id === webmodul['id_module'] ? true : false" v-html="languageData['m'+webmodul['id_module']]" :class="module_id === webmodul['id_module']?' router-link-exact-active router-link-active' :' router-link-active'"></router-link>
                                    
                                </li>
                            </ul>
                        </div> 
                    </div>  
                    <div class="col-md-9 col-lg-9 col-sm-9">
                                <!-- <template v-if="content_flag==true"> -->
                                

                        <div class="row">
                            <div class="col-md-12 col-sm-12 col-lg-12 custm-filter-wrap">
                                
                                <button type="button" aria-label="date filter" class="date-filter-enblebtn" @click="hideshowfilter()"><i class="filter-ico"></i>{{languageData['date']}}</button>
                                <Transition name="slide-fade">
                                <div v-if="dateFilterFlag" class="month-wrapp">
                                    
                                    <month-picker-input :clearable="false" :no-default="true" :lang="'en'" class="month-picker-wrap" @input="showDateFrom" @change="showDateFrom"></month-picker-input> 
                                    <span class="to-spann">To</span> 
                                    <month-picker-input :no-default="true" :lang="'en'" class="month-picker-wraptwo" @input="showDateTo" @change="showDateTo"></month-picker-input>
                                    <button type="button" aria-label="filter by date" class="btn submit btn-primary webinar-search-filter-btn" @click="checkDateFind()"><i class="icon-search3"></i></button>
                                    
                                </div>
                                </Transition>
                                <br/>
                                <p style="margin-top:60px;" v-if="((this.find_result_flg))" v-html="languageData['results']" role="alert" aria-atomic="true"></p>
                            </div>
                            <div class="col-md-12" v-if="content_flag==false">
                                <img  :src="LOCAL_HOST+'/ThemeMegazine/images/loader_dot.gif'" height="20" />
                            </div>
                            <div class=" animate-box webinar-grp-out" v-for="(el,ky) in main_content_all" :key="ky">
                                <div class="archives webinar-grp">
                                    <img :src="el['image']" class="webinargrp_img" alt=""/>
                                    <!-- <a class="article-title"  >sssss</a> -->
                                    <div class="webinar-title-wrap">
                                    <!-- <a class="webinar-title" href="/content/'+content['id_cr']" v-html="el['title']"></a> -->
                                    <router-link class="webinar-title" :to="'/content/'+el['id_cr']+'?d='+division_id+'&m='+module_to_content+'&cd='+cosmic_division_id" v-html="el['title']" ></router-link>
                                    </div>
                                    <span class="published_dt" >{{dateFormat(el['content_sort_date'])}}</span>
                                    
                                        <!-- <router-link :to="'/content/'+el['id_cr']+'/?d='+division_id+'&m='+module_id+'&e='+element_id" v-html="languageData['more']"  class="btn btn-primary with-arrow" v-if="el['view'] !=''"><i class="icon-arrow-right22"></i></router-link> -->
                                        
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>     
            <div class="row" id='showLoadMore'>
                <div class="col-md-12 animate-box">
                    <p><a href="" class="mouseover " @click.prevent="loadMorePage()">Load More Results</a></p>
                </div>    
            </div>
            <div class="col-md-12" v-if="this.loadImg==true && this.page != '0'">
                <img :src="LOCAL_HOST+'/ThemeMegazine/images/loader_dot.gif'" height="20" />
            </div>
           <!--  </template> -->
        </div>   
    </div>
</template>

<script>
import axios from 'axios';
import { MonthPickerInput } from 'vue-month-picker'

export default {
    name: 'mainContent',
    data(){
        return{
           // main_content:[],
            main_content_all:[],
            mainDataAll:[],
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN,
            LOCAL_HOST:this.$store.state.LOCAL_HOST,
            element_id: this.$route.query.e,
            module_id:this.$route.query.m,
            division_id:this.$route.query.d,
            cosmic_division_id:this.$route.query.cd,
            module_to_content:this.$route.query.m,
            //languageData:this.$store.state.languageData,
            isSticky: false,
            stickyClass: 'is_sticky',
            content_flag:false,
            loadMore: true,
            loadImg : true,
            page:0,
            limit:10,
            api_call:0,
            srchTitleTerm:this.$route.query.q,
            date:{
				from: null,
				to: null,
				month: null,
				year: null
			},
            dateTo:{
				from: null,
				to: null,
				month: null,
				year: null
			},
            dateFilterFlag:false,
            Todate:'',
            Fromdate:'',
            dateone_flg:1,
            datetwo_flg:1,
            find_result_flg:0

        };        
    },
    components:{
        MonthPickerInput
    },
    computed:{
        languageData() {
            // var titleValue =this.decodeHtmlLang(this.$store.state.languageData['d'+this.$route.params.division_id]);                
            //document.title = titleValue+' | '+this.$store.state.companyData['name_company'];
            return this.$store.state.languageData;
        }  
    },
    created :function(){
        this.getWebinars();
       /*this is to make element menu us sticky based on scroll */
        window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    },
    watch: {
        // call again the method if the route changes
        '$route': 'getWebinars'
    },
    mounted :function(){
        //this.handleScroll()
	},
	methods:{
        hideshowfilter(){
            
            if(this.dateFilterFlag ){

                if(!this.$route.query.df){
                    this.$router.push({path:this.$route.fullPath+'&df=0'});
                }else{
                    if(this.$route.query.df==0){
                        this.$router.push({path:this.$route.fullPath,query: {df: '1'}});
                    }else{
                        this.$router.push({path:this.$route.fullPath,query: {df: '0'}});
                        
                    }
                }

            }
            this.dateFilterFlag=!this.dateFilterFlag;
            this.Todate="";
            this.Fromdate="";
            this.dateone_flg=1;
            this.datetwo_flg=1;
            this.find_result_flg=0;
        },
        showDateFrom(date){
            this.date = date
            const monthpickers = document.getElementsByClassName("month-picker-input");
            if(this.date.from=='Invalid Date'){
                monthpickers[0].style.border = "2px solid #cd0a0a";
                this.dateone_flg=0;
            }
            else{
                monthpickers[0].style.border = "1px solid rgba(0, 0, 0, 0.15)";
                this.dateone_flg=1;
            } 
            this.Fromdate=this.date.from;
            /* console.log('dt1',this.date.from);
            console.log('dtto1',this.date.to); */
        },
        showDateTo(date){
            this.dateTwo = date;
            const monthpickersb = document.getElementsByClassName("month-picker-input");
            if(this.dateTwo.from=='Invalid Date'){
                monthpickersb[1].style.border = "2px solid #cd0a0a";
                this.datetwo_flg=0;
            }
            else{
                monthpickersb[1].style.border = "1px solid rgba(0, 0, 0, 0.15)";
                this.datetwo_flg=1;
            } 
            this.Todate=this.dateTwo.to;
        },

        getWebinars(){
            this.division_id=this.$route.query.d;
            this.cosmic_division_id=this.$route.query.cd;
            if(this.$route.query.m){
                this.module_to_content=this.$route.query.m;
            }
            else{
                this.module_to_content="";
            }
            
            this.page=0;
            this.find_result_flg=0;
            if(this.$route.query.q){
                this.findWebinarsSearch();
            }
            else{
                this.srchTitleTerm="";  
                if(this.dateFilterFlag){
                    this.hideshowfilter();
                }       
                this.content_flag=false;
                var idd_division=this.$route.query.d;
                var idd_element=601; //this.$route.query.e
                var module_id="";
                if(this.$route.query.m){
                    module_id=this.$route.query.m;
                }

                var api_private_key=this.get_api_key_mix('geta');
                axios.get(this.$store.state.apiUrl+'/get_amazon_webinar_data',{
                params:{id_element:idd_element,
                        id_division:idd_division,
                        id_module:module_id,
                        id_language:this.$store.state.companyData['id_language'],
                        id_company:this.$store.state.companyData['id_company'],
                        id_country:this.$store.state.companyData['id_country'], 
                        id_eap:this.$store.state.companyData['id_eap'],
                        privatekey:api_private_key,
                        limit:this.limit
                        }
                })
                .then(response => {
                    response = response.data;
                    this.mainDataAll=response;
                    response.forEach(element => {
                        if(module_id=="" && element.data.length>0){
                            module_id=element.id_module;
                        }
                        //if(element.data.length>0){
                        if(module_id==element.id_module){
                            this.module_id=element.id_module;
                            this.main_content_all = element.data;
                        }                        
                        //}
                    });
                    this.content_flag=true;
                    //this.$emit('content_ld_flagp_changed');
                    this.loadImg = false;
                    document.getElementById('showLoadMore').style.display = 'block';             
                    this.$nextTick(function () {
                    })
                })
                .catch((error) => {
                    this.main_content_all = [];
                    this.content_flag=true;
                    //this.customErrorHandler(error.response.status);
                });
            }
            //this.web_hits();
        },

        getWebinarsPagewise(scrollFlag){

            
            this.division_id=this.$route.query.d;
            this.loadImg=true;
            if(scrollFlag==0){
                this.content_flag=false;
            }
            var idd_division=this.division_id;
            var idd_element=601;
            //var idd_element="";
            //var module_id=this.$route.query.m;
            var module_id=this.module_id;
            var api_private_key=this.get_api_key_mix('gese');
            axios.get(this.$store.state.apiUrl+'/get_amazon_webinar_data_pagewise',{
              params:{
                    id_element:idd_element,
                    id_division:idd_division,
                    id_module:module_id,
                    id_language:this.$store.state.companyData['id_language'],
                    id_company:this.$store.state.companyData['id_company'],
                    id_country:this.$store.state.companyData['id_country'], 
                    id_eap:this.$store.state.companyData['id_eap'],
                    privatekey:api_private_key,
                    page:this.page,
                    limit:this.limit          
              }
            })
            .then(response => {
                response = response.data
                //console.log('pageData-',response.data);
                if(response.length>0){
                    this.main_content_all = this.main_content_all.concat(response);
                    document.getElementById('showLoadMore').style.display = 'block';
                }
                else {
                    this.loadMore = false;
                    document.getElementById('showLoadMore').style.display = 'none';
                }
                
                this.loadImg = false;
                this.api_call=0;
            })
            .catch((error) => {
                //this.main_content_all = [];
                //this.customErrorHandler(error.response.status);
            });
        },
        searchURLPush(){
            if(this.srchTitleTerm){
                if(!this.$route.query.m){
                     this.$router.push({path:this.$route.fullPath+'&m='+this.module_id});
                }
                if(!this.$route.query.q){
                    this.page=0;
                    this.$router.push({path:this.$route.fullPath+'&q='+this.srchTitleTerm});
                }else{
                    this.$router.push({path:this.$route.fullPath,query: {q: this.srchTitleTerm}});//replace existing q with new val
                }
            }
        },
        checkDateFind(){

            if(this.Fromdate!="" && this.Todate!=""){
                this.page=0;
                this.main_content_all=[];
                this.findWebinarsSearch();
            }
        },
        findWebinarsSearch(){
             this.loadImg = false;
            document.getElementById('showLoadMore').style.display = 'block';
            //this.page=0;
            this.find_result_flg=0; 
            if(this.dateone_flg && this.datetwo_flg){

               /*  if(document.getElementById('showLoadMore')){
                    document.getElementById('showLoadMore').style.display = 'none';
                } */
                this.content_flag=false;
                var idd_division=this.$route.query.d;
                var idd_element=601; //this.$route.query.e
                var module_id=this.module_id;
                //console.log('mmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmm');
                if(this.$route.query.m){
                    module_id=this.$route.query.m;
                }

                var search_word=this.srchTitleTerm;
                //this.main_content_all = [];

                var api_private_key=this.get_api_key_mix('fita');
                axios.get(this.$store.state.apiUrl+'/find_amazon_webinar_data',{
                params:{
                        id_element:idd_element,
                        id_division:idd_division,
                        id_module:module_id,
                        id_language:this.$store.state.companyData['id_language'],
                        id_company:this.$store.state.companyData['id_company'],
                        id_country:this.$store.state.companyData['id_country'], 
                        id_eap:this.$store.state.companyData['id_eap'],
                        privatekey:api_private_key,
                        page:this.page,
                        search_word:search_word,
                        from_date:this.Fromdate,
                        to_date:this.Todate,
                        limit:this.limit
                    }
                })
                .then(response => {
                    console.log('pppage-',this.page);
                    var respVal=response;
                    response = response.data;
                    console.log('repnslengthout-',response.length);
                    if(response.length<=0 && this.page<=0){
                        this.main_content_all = [];
                        console.log('repnslength-',response.length);
                        document.getElementById('showLoadMore').style.display = 'none';
                        //this.loadMore = false;
                        this.find_result_flg=1;
                        //document.getElementById('showLoadMore').style.display = 'none';
                    }
                    else if(this.page>0 && response.length>0){
                        console.log('hhhhhhhhhhhhhhhhoo',this.main_content_all);
                        this.main_content_all = this.main_content_all.concat(response);
                        document.getElementById('showLoadMore').style.display = 'block';
                        console.log('hhhhhhhhhhhhhhhhoo2',this.main_content_all);
                    }
                    else if(this.page>0 && response.length<=0) {
                        //this.loadMore = false;
                        this.content_flag=true;
                       
                        console.log('repnslengthpage>0-',response.length);
                        document.getElementById('showLoadMore').style.display = 'none';
                        return false;
                    }
                   else{
                     console.log('repnslengthinside-',response.length);
                        this.main_content_all = [];
                        this.main_content_all = response;
                    }
                    
                    this.content_flag=true;
                    //this.$emit('content_ld_flagp_changed');
                    this.loadImg = false;
                    //document.getElementById('showLoadMore').style.display = 'block';
                })
                .catch((error) => {
                    this.main_content_all = [];
                    this.content_flag=true;
                    //this.customErrorHandler(error.response.status);
                }); 

                if(this.mainDataAll.length<=0){
                    this.getWebinarsModules();
                }
                //this.web_hits();
            }
        },
        getWebinarsModules(){  
                this.content_flag=false;
                var idd_division=this.$route.query.d;
                var idd_element=601; //this.$route.query.e
                var module_id="";
                if(this.$route.query.m){
                    module_id=this.$route.query.m;
                }

                var api_private_key=this.get_api_key_mix('gees');
                axios.get(this.$store.state.apiUrl+'/get_amazon_webinar_modules',{
                params:{id_element:idd_element,
                        id_division:idd_division,
                        id_module:module_id,
                        id_language:this.$store.state.companyData['id_language'],
                        id_company:this.$store.state.companyData['id_company'],
                        id_country:this.$store.state.companyData['id_country'], 
                        id_eap:this.$store.state.companyData['id_eap'],
                        privatekey:api_private_key
                        }
                })
                .then(response => {
                    response = response.data;
                    this.mainDataAll=response;
                    this.content_flag=true;
                    this.loadImg = false;
                })
                .catch((error) => {
                    this.content_flag=true;
                    //this.customErrorHandler(error.response.status);
                });
            
        },
        handleScroll(event){
            /*this is to make element menu us sticky based on scroll */
            this.scrollPosition = window.scrollY
            if(this.scrollPosition>=900){
                this.isSticky=true
            }else{this.isSticky=false}
            window.onscroll = () => {
                //console.log(this.$el.clientHeight+'-'+document.body.scrollHeight+'-'+window.innerHeight+'-'+document.body.scrollTop);
                if(screen.width <= '991'){
                    if(this.scrollPosition >= (this.$el.clientHeight - 500)  && this.loadMore && this.api_call==0){
                        this.loadImg = true;
                        ++this.page;
                        this.api_call=1;
                        //this.getWebinarsPagewise(this.element_id,1);
                    }
                } else {
                    let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.body.offsetHeight;

                    if (bottomOfWindow && this.loadMore && this.api_call==0) {
                        this.loadImg = true;
                        ++this.page;
                        this.api_call=1;
                        //this.getWebinarsPagewise(1);
                        if((this.$route.query.q) || (this.Fromdate!="" && this.Todate!="")){
                            this.findWebinarsSearch();
                        }else{
                            this.getWebinarsPagewise(1);
                        }
                    }
                }
            };
        },
        loadMorePage(){
            document.getElementById('showLoadMore').style.display = 'none';
            this.loadImg = true;
            ++this.page;
            var search_word=this.srchTitleTerm;
            if((this.$route.query.q) || (this.Fromdate!="" && this.Todate!="")){
                this.findWebinarsSearch();
            }else{
                this.getWebinarsPagewise(1);
            }
        },
        dateFormat(v) {
            var today = new Date(v);
            //var now_time = 'Published on '+(today.getDay() + " " + today.getMonth() + " " + today.getFullYear()).toString();
            var options = { year: 'numeric', month: 'short', day: 'numeric' };
           /*console.log(today.toLocaleDateString("en-US")); // 9/17/2016
            console.log(today.toLocaleDateString(localStorage.lang_abbrevation, options)); // Saturday, September 17, 2016
            console.log(today.toLocaleDateString("fr-FR", options)); */
            var now_time= 'Published on '+today.toLocaleDateString(localStorage.lang_abbrevation, options);
            return now_time;
        }
    }
};
</script>
<style scoped>
.content-wrap {
    padding-right: 17px;
    text-align: initial;
    width: -webkit-fill-available;
}
.pagination{
    padding-left: 16px;
}
.pagination li a {
    border: none;
    padding: 10px 18px !important;
}
.pagination li a:hover, .pagination li a:focus,.pagination li.active a:hover, .pagination li.active a:focus  {
    border: none !important; 
}
.pagination li.active a {
    border: none !important; 
}
.archives{
    padding-bottom: 0px;
}
.archives .tag {
    margin: 10px 0 0 0;
    font-size: 10px;
    font-weight: 300;
    text-transform: uppercase;
    letter-spacing: 3px;
    text-align: right;
    float:right;
}
.article-title{
    
    font-weight: 300;
    text-transform: uppercase;
    font-size: 24px;    
    color: #000;
    line-height: 1.3;
}
.ratings{
    font-size: 23px !important;
    color: #e07c56;
    font-weight: bold !important;
    /* font-family: fantasy !important; */
    vertical-align: top;
    vertical-align: -webkit-baseline-middle;
}
.is_sticky {
    position: fixed;
    background-color: #fffffffc;
    top: 0;
    /* right: 0;
    left: 0; */
    z-index: 1030;
    /* width: 100%; */
    -webkit-animation: .95s ease-in-out 0s normal none 1 running fadeInDown;
    animation: .95s ease-in-out 0s normal none 1 running fadeInDown;
    -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    /* -webkit-box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.1); */       
    padding: 0;
    margin:0;
    /* width:81%; */
}
@media screen and (max-width: 768px){
    .content-wrap{
        padding-left: 0 !important; 
    }
}
#showLoadMore{
    display: none;
}
.mouseover{
    cursor: pointer;
    float:right;
}

.webinar-grp{
    /* height: 300px; */
    background: #FCFCFC;
    border-radius: 6px;
    padding: 10px;
    min-height: 238px;
}
@media (min-width: 768px) {
    .col-md-6 {
        width: 50% !important;
    }
}

.webinar-grp-out{
    width: 332px !important;
    padding: 0 15px;
    margin-bottom: 30px;
}
.webinargrp_img{
    width: 280px;
    /* height: 158px; */
}
.webinar-title{
    font-size: 15px;
    color: #333333;
    font-weight:bold;
}
.webinar-title-wrap{
    height: 50px;
    margin: 10px 0 0;
    overflow-y: auto;
    line-height: 22px;
}
.published_dt{
    font-size: 13px;
}
.webinar-srch-box{
    border: 1px solid #000 !important;
    border-radius: 10px;
    height: 40px;
    padding-right:50px !important;
}
.webinar-search-btn{
    height: 40px !important;
    border-radius: 0 10px 10px 0 !important;
    background: #ffffff !important;
    color: #000 !important;
    top: 0px !important;
    right: 1px !important;
    border: none !important; 
    box-shadow: none !important;
    border-right: 1px solid #545557 !important;
    border-top: 1px solid #545557 !important;
    border-bottom: 1px solid #545557 !important;
}
.webinar-search-btn:hover, .webinar-search-btn:focus, .webinar-search-btn:active {
    background: #0f2d59 !important;
    border-color: #0f2d59 !important;
    color: #ffffff !important;
}
.webinar-search-filter-btn{
    height: 38px !important;
    border-radius: 10px !important;
    background: #0f2d59 !important;
    color: #ffffff !important;
    top: 1px !important;
    right: 16px !important;
    border: none !important;
    box-shadow: none !important;
    position: relative !important;
    left:15px !important;
}
.router-link-active{
    color: #132541 !important;
    font-weight: 500 !important;
    font-size: 15px !important;

}
.router-link-exact-active{
    font-weight: bold !important;
    color: #113367 !important;
}

.month-picker-wrap{
    z-index: 100 !important;
     float: left;
      
    /* margin-right: 39px; */
}

.month-picker-wraptwo{
    z-index: 99 !important;
     float: left;
}
.custm-filter-wrap{
    margin-bottom: 20px;
}
.to-spann{
    float: left;
    margin: 6px;
}
.filter-ico{
    background: transparent url(/img/filter.png) 0% 0% no-repeat padding-box;
    float: right;
    width: 17px;
    height: 28px;
    margin-top: 4px;
    background-position-x: 0px;
}
.date-filter-enblebtn{
    float: right;
    border: none;
    background: white;
}



.slide-fade-enter-active {
  /* transition: all 5.5s ease-out;
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1); */
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(5px);
  opacity: 0;
}
.slide-fade-enter-from{
   /*  
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1); */
}
.month-wrapp{
    float: right !important;
    margin-right: 30px !important;
}
</style>
<style>
.month-picker-wrap button, .month-picker-wraptwo button {
    height: 3.75rem !important;
}

.month-picker-wrap .month-picker-input{
    height: 40px;
    width: 155px;
    
}
.month-picker-wraptwo .month-picker-input{
    height: 40px;
    width: 155px;
}
.month-picker-input-container{
    width: auto !important;
}
</style>
